// Copyright (c) 2022 by Move Closer

import { ModulesFormRegistryEntry } from '../../../contexts'

import { productReviewsFactory } from '../ProductReviews.factory'
import { ProductReviewsVersion } from '../ProductReviews.contracts'

/**
 * @author Katarzyna Otto <katarzyna.otto@movecloser.pl>
 */
export const productReviewsModuleEntry: ModulesFormRegistryEntry = {
  component: () => import(
    /* webpackChunkName: "form/core" */ './ProductReviews.form.vue'),
  factory: productReviewsFactory,
  // FIXME: icon should be change to correct one
  icon: require('../productReviews.svg'),
  label: 'modulesForms.ProductReviews._name',
  versions: {
    [ProductReviewsVersion.LoadMore]: 'modulesForms.ProductReviews.versions.loadMore',
    [ProductReviewsVersion.Paginate]: 'modulesForms.ProductReviews.versions.paginate'
  },
  restrictions: {
    allowedTypes: ['product', 'snippet']
  }
}
